import { getBaseRequestConfig } from "../baseRequestConfig";
import asyncFetch from "../async-fetch";

export async function ChannelProfile() {
  const url = process.env.REACT_APP_API_URL + "/channel/profile";
  const baseRequestConfig = getBaseRequestConfig();
  const response = await asyncFetch(url, baseRequestConfig);
  return await response;
}
